import { Component, OnDestroy, OnInit } from '@angular/core';
import { FlyToOptions } from '@trimblemaps/trimblemaps-js';
import { isEqual } from 'lodash-es';
import { Observable, of, Subscription } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { MapService } from 'src/app/services/map.service';
import { NextPrevService } from 'src/app/services/next-prev.service';
import { SubscriptionManager } from 'src/app/_helpers/subscription-manager';
import { mapLocationOption } from 'src/app/_models/mapLocationOption';
@Component({
  selector: 'app-next-previous-view',
  templateUrl: './next-prev-view.component.html',
})
export class NextPrevViewComponent implements OnInit, OnDestroy {
  navLimit = 50;
  isForwardBtnDisabled$: Observable<boolean>;
  isBackBtnDisabled$: Observable<boolean>;
  private sm = new SubscriptionManager();
  constructor(
    private mapService: MapService,
    private nextPrevService: NextPrevService
  ) {}

  ngOnInit(): void {
    // subscribe to zoomstart event
    this.nextPrevService.clearPrevStack();
    this.sm.manage = this.mapService.mapLocation$
      .pipe(filter((data: mapLocationOption) => data.source === 'DEFAULT'))
      .subscribe((options: FlyToOptions) => {
        this.setNavigationHistory(options);
      });

    this.isBackBtnDisabled$ = this.nextPrevService.backBtnchange$.pipe(
      map((option) => !option),
      mergeMap(() => of(this.nextPrevService.prevStackValue.length === 1))
    );
    this.isForwardBtnDisabled$ = this.nextPrevService.forwardBtnchange$.pipe(
      map((option) => !option)
    );
  }

  goBack(): void {
    const current = this.nextPrevService.shiftprevStack();
    const state = this.nextPrevService.shiftprevStack();
    if (state) {
      this.nextPrevService.addInNextStack(current);
      this.nextPrevService.addInPrevStack(state);
      this.redrawMap(state);
      this.nextPrevService.updateForwardBtn(
        this.nextPrevService.nextStackValue[0]
      );
      this.nextPrevService.updateBackBtn(
        this.nextPrevService.prevStackValue[1]
      );
    } else {
      this.nextPrevService.addInPrevStack(current);
    }
  }

  goForward(): void {
    const state = this.nextPrevService.shiftnextStack();
    if (state) {
      this.nextPrevService.addInPrevStack(state);
      this.redrawMap(state);
      this.nextPrevService.updateForwardBtn(
        this.nextPrevService.nextStackValue[0]
      );
      this.nextPrevService.updateBackBtn(
        this.nextPrevService.prevStackValue[1]
      );
    }
  }
  redrawMap(state: FlyToOptions) {
    const eventData = { source: 'nextPrevView' };
    this.mapService.flyTo(state, eventData);
  }
  // adding mapping event to navHistory array
  setNavigationHistory(option: FlyToOptions) {
    this.loadPrevStack(option);
    this.nextPrevService.updateBackBtn(option);
  }
  loadPrevStack(state: FlyToOptions) {
    // storing only specific no. item in the history
    if (this.nextPrevService.prevStackValue.length < this.navLimit) {
      this.avoidDuplicate(state);
    } else {
      // if the array length is more than specified length. removing the item like FIFO
      this.nextPrevService.popPrevStack();
      this.avoidDuplicate(state);
    }
  }
  // elimate duplicate value added , when navigating from one route to another
  avoidDuplicate(curr: FlyToOptions) {
    if (this.nextPrevService.prevStackValue[0]) {
      const firstele = this.nextPrevService.prevStackValue[0];
      if (!isEqual(firstele, curr)) {
        this.nextPrevService.addInPrevStack(curr);
      }
    } else {
      this.nextPrevService.addInPrevStack(curr);
    }
    if (this.nextPrevService.nextStackValue.length > 0) {
      this.nextPrevService.clearNextStack();
      this.nextPrevService.updateForwardBtn(null);
    }
  }
  ngOnDestroy(): void {
    // unsubscribing the listener observable

    this.sm.unsubscribe();
  }
}
